<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { calculateVariation } from '@/utils/math';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'NewFans',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getPerformancePageMetricsServiceWithVariation',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getPerformancePageMetricsServiceWithVariation({
        itemId: this.itemId,
        servicePath: 'metricsFanEvolution',
      })
        .then(response => {
          const [start, end] = response;

          const previous = this.getTotalNewFansPerPeriod(start);
          const current = this.getTotalNewFansPerPeriod(end);
          const variation = calculateVariation(previous, current);

          const isThereVariation = variation !== undefined;

          this.value = current;
          this.variation = variation;
          this.rawVariation = isThereVariation ? variation : current;
          this.comparationValue = formatSocialNumberWithDecimal(previous);
          this.requestStatus = 'success';
        })
        .catch((err) => {
          console.error('err:', err);
          this.requestStatus = 'error';
        });

      if (options?.silentRefresh) {
        EventBus.$emit('updated', { itemId: this.itemId });
      }
    },
    getTotalNewFansPerPeriod(period) {
      let fansPerPeriod = 0;
      const newFansResource = period
        .filter(promise => promise.status === 'fulfilled' && !promise.value.error)
        .map(resource => resource.value.results);

      newFansResource.forEach(resource => {
        resource.forEach(base => {
          if (base.name === 'FanBase') {
            const dataLength = base.data?.length;

            const previousDate = base.data[0]?.value || 0;
            const currentDate = base.data[dataLength - 1]?.value || 0;

            fansPerPeriod += currentDate - previousDate;
          }
        });
      });

      return fansPerPeriod;
    },
  },
};
</script>
